module.exports = require("././angular-animate.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-animate (bower component)
 ** module id = 154
 ** module chunks = 0
 **/